import { secondsToTimeString } from '@/helpers/dateHelper';
import { FC } from 'react';

interface Props {
  counts: number[];
}

export const ShiftHourSummary: FC<Props> = ({ counts }) => {
  return (
    <div className="flex-1">
      <div className="flex flex-row bg-background-mid border-b pr-9">
        {counts.map((count, index) => {
          return (
            <div className="flex-1 py-2 text-center text-black border-r" key={index}>
              {secondsToTimeString(count)}
            </div>
          );
        })}
      </div>
    </div>
  );
};
